import { gql } from "apollo-boost";

const reports = gql`
  query ($filter: ReportFilter) {
    reports(filter: $filter) {
      total
      items {
        id
        user {
          id
          name
        }
        createDate
        title
        content
        state
        operationDate
        operator {
          id
          name
        }
      }
    }
  }
`;

export const acceptReport = gql`
  mutation acceptReport($id: String!, $note: String) {
    acceptReport(id: $id, note: $note)
  }
`;

export const rejectReport = gql`
  mutation rejectReport($id: String!, $note: String) {
    rejectReport(id: $id, note: $note)
  }
`;

export const reportGql = { reports, acceptReport, rejectReport };
